exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".has-subtitle[data-v-4e63c0c4]{display:inline-block}li[data-v-4e63c0c4]{margin-bottom:1rem}li[data-v-4e63c0c4]:last-child{margin-bottom:0}.description[data-v-4e63c0c4]{margin-bottom:1rem}.info.row[data-v-4e63c0c4]{margin-bottom:-1rem}.info.row>div[data-v-4e63c0c4]{margin-bottom:1rem}.schedule .day[data-v-4e63c0c4]{visibility:hidden}.schedule .first-day[data-v-4e63c0c4]{visibility:visible}.calendar[data-v-4e63c0c4]{margin-bottom:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e63c0c4","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Colloquium/Schedule.vue
// module id = 1238
// module chunks = 0